export enum FilterOptionsEnum {
  Contract = 'CONTRACT',
  Project = 'PROJECT',
  VerticalSignaling = 'VERTICAL_SIGNALING',
  HorizontalSignaling = 'HORIZONTAL_SIGNALING',
  DeviceSignaling = 'DEVICE_SIGNALING',
  Region = 'REGION',
  Area = 'AREA',
  TimeInterval = 'TIME_INTERVAL',
  Responsible = 'RESPONSIBLE',
  Address = 'ADDRESS',
  MaintenanceTimeInterval = 'MAINTENANCE_TIME_INTERVAL',
  ContractVerticalItem = 'CONTRACT_VERTICAL_ITEM',
  ContractHorizontalItem = 'CONTRACT_HORIZONTAL_ITEM',
  ContractDeviceItem = 'CONTRACT_DEVICE_ITEM',
  Occurrences = 'OCCURRENCES',
  TeamLeader = 'TEAM_LEADER',
  TaskStatus = 'TASK_STATUS',
  TaskPriority = 'TASK_PRIORITY',
  Vehicle = 'VEHICLE',
  ServiceOrder = 'SERVICE_ORDER',
  RegisterId = 'REGISTER_ID',
}
